import { initializeApp, getApps } from 'firebase/app';
import {
  GoogleAuthProvider,
  getAuth,
  setPersistence,
  browserLocalPersistence,
  onAuthStateChanged,
  signInWithRedirect,
  signInWithPopup,
  getRedirectResult,
  signOut,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  type User,
} from 'firebase/auth';

const cleanEnv = (value: string | undefined) => value?.trim() || undefined;

const firebaseConfig = {
  apiKey: cleanEnv(import.meta.env.VITE_FIREBASE_API_KEY),
  authDomain: cleanEnv(import.meta.env.VITE_FIREBASE_AUTH_DOMAIN),
  projectId: cleanEnv(import.meta.env.VITE_FIREBASE_PROJECT_ID),
  storageBucket: cleanEnv(import.meta.env.VITE_FIREBASE_STORAGE_BUCKET),
  messagingSenderId: cleanEnv(import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID),
  appId: cleanEnv(import.meta.env.VITE_FIREBASE_APP_ID),
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
export const firebaseAuth = getAuth(app);

void setPersistence(firebaseAuth, browserLocalPersistence).catch(() => {
  // Ignore persistence setup failures; sign-in can still proceed.
});

export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

export const signInWithGoogle = (options?: { preferRedirect?: boolean }) => {
  if (options?.preferRedirect) {
    return signInWithRedirect(firebaseAuth, googleProvider);
  }

  return signInWithPopup(firebaseAuth, googleProvider);
};
export const getFirebaseRedirectResult = () => getRedirectResult(firebaseAuth);
export const signInWithEmailPassword = (email: string, password: string) =>
  signInWithEmailAndPassword(firebaseAuth, email, password);
export const signUpWithEmailPassword = (email: string, password: string) =>
  createUserWithEmailAndPassword(firebaseAuth, email, password);
export const signOutFromFirebase = () => signOut(firebaseAuth);
export const subscribeToFirebaseAuth = (callback: (user: User | null) => void) =>
  onAuthStateChanged(firebaseAuth, callback);
